exports.list = {
    path: '/laporan_cek_card',
    name: 'laporan_cek_card', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_cek_card/List.vue"),
  }
  